/*
 *  REST Service object: TrackerRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { doGetPromise, doDeletePromise } from '../../core/config/core.httpclient-utils';
@Injectable()
export class ReminderService {

    private baseUrl = '/api/reminder';

    constructor(private http: HttpClient) {
        this.http = http;
    }

    post(body: any = {}) {
        return this.http.post(
            this.baseUrl, body
        ).toPromise();
    }

    fetch(params: any = {}) {
        return doGetPromise(this.http, this.baseUrl, params);
    }

    delete(id) {
        return doDeletePromise(this.http, `${ this.baseUrl }/${ id }`);
    }
}